/**
 * Test IDs for QA automation.
 */
export const testIds = {
  extensionsWidgetsOpenWidget: "extensions-widgets-open-widget",
  extensionsWidgetsClose: "extensions-widgets-close",
} as const;
